<script setup>
const props = defineProps({
  spriteIcon: {
    type: String,
    required: true,
  },

  text: {
    type: String,
    required: true,
  },

  title: {
    type: String,
    default: undefined,
  },

  size: {
    type: String,
    default: 'lg',
    validator(value) {
      return ['md', 'lg'].includes(value);
    },
  },
});

const { $tp } = useNuxtApp();
</script>

<template>
  <div
    class="feature-block"
    :class="{
      [`feature-block--size--${props.size}`]: props.size,
    }"
  >
    <div class="feature-block__wrapper feature-block__wrapper--feature-icon">
      <CSpriteIcon
        name="grid_round_2-3_s"
        class="feature-block__icon feature-block__icon--grid-round"
      />

      <CSpriteIcon
        v-if="props.spriteIcon"
        :name="props.spriteIcon"
        class="feature-block__icon feature-block__icon--feature"
      />
    </div>

    <div v-if="props.title" class="feature-block__title">
      <span
        class="feature-block__font feature-block__font--title"
        v-html="$tp(props.title)"
      >
      </span>
    </div>

    <p class="feature-block__text">
      <span
        class="feature-block__font feature-block__font--text"
        v-html="$tp(props.text)"
      >
      </span>
    </p>

    <div class="feature-block__footer">
      <CSpriteIcon
        name="skewed_grid_bullet"
        class="feature-block__icon feature-block__icon--grid-bullet"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.feature-block {
  $parent: &;

  &__font {
    display: block;

    &--text {
      font-family: $font-family-second;
      font-size: em(12);
      font-weight: 500;
      line-height: 115%;
    }

    &--title {
      font-size: em(16);
      font-weight: 800;
      line-height: 115%;

      @include media-breakpoint-down(md) {
        font-size: em(13);
      }

      @include media-breakpoint-down(sm) {
        font-size: em(16);
      }
    }
  }

  &__icon {
    &--feature {
      position: relative;
      z-index: 1;
      width: em(32);
      height: em(32);
    }

    &--grid-round {
      position: absolute;
      top: 0;
      left: 0;
      width: em(50);
      height: em(50);
      opacity: 0.5;
    }

    &--grid-bullet {
      width: em(35);
      height: em(8);
      opacity: 0.5;
    }
  }

  &__wrapper {
    &--feature-icon {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: em(50);
      height: em(50);
    }
  }

  &__title {
    margin-top: em(13);
    color: $text-dark-main;
  }

  &__text {
    margin-top: em(10);
    margin-bottom: em(10);
    color: $text-dark-secondary;
  }

  &--size {
    &--md {
      #{$parent} {
        &__font {
          &--text {
            @include media-breakpoint-down(md) {
              font-size: em(9);
              line-height: 130%;
              letter-spacing: 0.03em;
            }

            @include media-breakpoint-down(sm) {
              font-size: em(12);
              line-height: 118%;
              letter-spacing: -0.001em;
            }
          }
        }

        &__icon {
          &--feature {
            @include media-breakpoint-down(md) {
              width: em(25);
              height: em(25);
            }

            @include media-breakpoint-down(sm) {
              width: em(32);
              height: em(32);
            }
          }

          &--grid-round {
            @include media-breakpoint-down(md) {
              width: em(40);
              height: em(40);
            }

            @include media-breakpoint-down(sm) {
              width: em(50);
              height: em(50);
            }
          }
        }

        &__wrapper {
          &--feature-icon {
            @include media-breakpoint-down(md) {
              width: em(40);
              height: em(40);
            }

            @include media-breakpoint-down(sm) {
              width: em(50);
              height: em(50);
            }
          }
        }
      }
    }

    &--lg {
      #{$parent} {
      }
    }
  }
}
</style>
